import {
	PurchaseOrderDetailDto,
	PurchaseOrderHeaderDto,
} from "src/dtos/purchaseOrder/purchaseOrderDto";
import { formatDate } from "src/utils/string/stringUtil";

export interface PUR1040_R01Dto {
    purchaseOrderHdrDto: PUR1040_R01HeaderDto;
    purchaseOrderDetailDtoList: PUR1040_R01DetailDto[];
}

export interface PUR1040_R01HeaderDto extends PurchaseOrderHeaderDto {
    wmsOrderNo: string | null;
    taxBilling: string | null;
    taxBillNo: string | null;

    // 코드명
    vatTypeNm: string;
    logicCenterNm: string;
    orderStatusNm: string;

    // 주소
    post: string | null;
    address: string | null;
    otherAddress: string | null;
}

export const defaultPUR1040_R01HeaderDto: PUR1040_R01HeaderDto = {
    valueIndex: 0,
    orderIndex: 0,
    orderIndexSeq: 0,

    purchaseOrderNo: '',
    wmsOrderNo: null,

    compCd: '',
    compNm: '',

    orderDt: formatDate(new Date()),

    customCd: '',
    customNm: '',

    moneyCd: '',
    vatType: '',

    empNo: '',
    empNm: '',

    logicCenter: '',

    orderAmt: 0,
    vatAmt: 0,
    totalAmt: 0,

    dueDt: formatDate(new Date()),

    telNo: '',
    faxNo: '',
    email: '',

    taxBilling: null,
    taxBillNo: null,

    approveFlg: 'N',
    orderStatus: '',

    remark: '',


    vatTypeNm: '',
    logicCenterNm: '',
    orderStatusNm: '',

    post: null,
    address: null,
    otherAddress: null,
    totBaseVat: '',
    inserted: false,
    isModified: false,
};

export interface PUR1040_R01DetailDto extends PurchaseOrderDetailDto {
    locationCd?: string;
    locationNm?: string;

    brandCd?: string;
    itemGroup?: string;
    itemGroupNm?: string;
    itemAccount?: string;
    itemAccountNm?: string;
    brandNm?: string;
    stockQty?: number | null;
}

export const defaultPUR1040_R01DetailDto: PUR1040_R01DetailDto = {
    valueIndex: 0,
    orderIndex: 0,
    orderIndexSeq: 0,
    inserted: false,
    isModified: false,

    purchaseOrderNo: '',
    itemNo: '',

    itemCd: '',
    itemNm: '',
    itemSpec: '',
    locationCd: '',
    locationNm: '',
    modelNo: '',

    compCd: '',
    orderDt: formatDate(new Date()),
    customCd: '',

    itemSeq: 1,

    orderUnit: '',
    orderQty: 0,
    orderPrice: 0,
    dcAmt: 0,
    itemAmt: 0,

    remark: '',



    brandCd: '',
    itemGroup: '',
    itemGroupNm: '',
    itemAccount: '',
    itemAccountNm: '',
    brandNm: '',
    stockQty: null,
    cancelQty: 0,
};

